import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    standalone: false,
    host: {
        '[class.tile-disabled]': 'disabled'
    }
})
export class TileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input()
  icon: any;

  @Input()
  text!: string;

  @Input()
  link!: string;

  @Input()
  disabled: boolean = false;

}
